<template>
    <div id="box_component" class="box-component">
        <div class="box-component-inner">
            <h2>Two-step verification</h2>
            <form @submit.prevent="validate">
                <div class="mw--360">
                    <p>Enter your token below:</p>
                    <div class="form-item form-item-text" :class="{ 'field-error': (errors.has('token') && showErrors) || incorrect }">
                        <input  id="login_token"
                                name="token"
                                v-model="token"
                                v-validate
                                data-vv-rules="required"
                                data-vv-as="token"
                                :disabled="progress"
                                type="text">
                        <p class="field-error--description" v-show="errors.has('token') && showErrors">{{ errors.first('token') }}</p>
                        <p class="field-error--description" v-show="incorrect">Incorrect token. Try again.</p>
                    </div>
                </div>
                <div class="form-actions">
                    <button class="button--primary login"
                            :class="{ 'button--progress': progress }"
                            :type="progress ? 'button' : 'submit'">Confirm</button>
                    <p @click="changeView(0)"
                       class="button--text">Back to login</p>
                </div>
                <div>
                    <br>

                    If You have problem in two-step verification,<br>
                    please contact with our support team by e-mail
                    <a href = "mailto: futuronetwork.help@gmail.com ">futuronetwork.help@gmail.com </a>.
                    <br>
                </div>


            </form>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['api', 'popup', 'recaptcha', 'status', 'user'],
        props: ['captchaValue'],
        data () {
            return {
                incorrect: false,
                progress: false,
                showErrors: false,
                token: '',
            }
        },
        computed: {
            verificationType () {
                return this.$store.getters.settings.confirmations.twoStepLogin
            }
        },
        methods: {
            changeView (view) {
                this.$store.commit('loginFormView', 2)
                setTimeout(() => {
                    this.$store.commit('loginFormView', view)
                }, 600)
            },
            loginSuccess(data) {
                this.progress = false
                this.user.fetchData(data)
                this.$router.push({ name: 'Dashboard' })
            },
            validate (e) {
                this.showErrors = false
                this.$validator.validateAll()

                if (!this.errors.any()) {
                    this.submit()
                }
                else {
                    this.showErrors = true
                }
            },

            submit () {
                this.incorrect = false
                this.progress = true
                let username = document.querySelector('#field_username').value,
                    password = document.querySelector('#field_password').value

                this.$http.post(this.api.auth.login, {
                    _username: username,
                    _password: password,
                    token: this.token,
                    'g-recaptcha-response': this.captchaValue
                }).then(response => {
                    this.loginSuccess(response.data);
                    this.recaptcha.SetRecaptchaResponse(null);
                }, error => {
                    setTimeout(() => {
                        this.progress = false
                        switch (error.status) {
                            case (423):
                                this.incorrect = true
                                break
                            default:
                                if (this.status['status' + error.status]) {
                                    this.status['status' + error.status]()
                                } else {
                                    this.popup.show(error.data.errors[0].message)
                                }
                        }
                    }, 1000)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_colors.scss';
    @import '../../../assets/scss/_guest.scss';

    .button--text{
        font-size: 12px !important;
        margin: 15px auto -30px;
        cursor: pointer;

        &:hover,
        &:focus{
            text-decoration: underline;
         }
    }
</style>



// WEBPACK FOOTER //
// src/components/login/partials/TokenForm.vue